import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MicrosoftIntuneService } from '../../service';

export type ConditionalAccessPolicyDefinitionConfig =
  typeof ConditionalAccessPolicyDefinitionConfig._.Config;

export const ConditionalAccessPolicyDefinitionConfig = IntegrationConfig.make({
  service: MicrosoftIntuneService,
  name: Integration_Handler_Names_Enum.ConditionalAccessPolicyDefinition,
  configSchema: z.object({
    policyId: z.uuid(),
  }),
});
